// https://experienceleague.adobe.com/docs/dynamic-media-developer-resources/image-serving-api/image-rendering-api/http-protocol-reference/http-protocol-command-reference/r-ir-align.html?lang=en
export const SCENE7_CMDS = [
  'align',
  'anchor',
  'bgc',
  'cache',
  'color',
  'decal',
  'flags',
  'fmt',
  'gloss',
  'glossmap',
  'grout',
  'hei',
  'hide',
  'icc',
  'iccEmbed',
  'illum',
  'obj',
  'opac',
  'pathEmbed',
  'printRes',
  'qos',
  'qlt',
  'repeat',
  'req',
  'res',
  'resMode',
  'rotate',
  'rough',
  'rs',
  'scl',
  'sel',
  'sharp',
  'sharpen',
  'show',
  'size',
  'src',
  'sub',
  'type',
  'vignette',
  'wid',
  'op_usm',
];

// https://experienceleague.adobe.com/docs/dynamic-media-classic/using/master-files/best-practices-optimizing-quality-images.html?lang=en
export const DEFAULT_SCENE7_MODIFIERS = {
  qlt: '85,0',
  resMode: 'sharp2',
  op_usm: '1.75,0.3,2,0',
};
export const ADJUSTED_SCENE7_MODIFIERS = {
  fmt: 'webp',
  qlt: '80,0',
  resMode: 'sharp2',
  op_usm: '1.75,0.3,2,0',
};
